import { createFileRoute } from '@tanstack/react-router'
import styled from 'styled-components'

import { Card, ContentWrapper, H3, H6 } from '~/components/elements'
import { MakeComplaint } from '~/components/support/MakeComplaint'

const ComplaintBanner = styled.div`
  text-align: center;
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid ${(props) => props.theme.border.color};
  border-radius: 5px;
`

export const Route = createFileRoute('/_authenticated/support/new-complaint')({
  component: SupportNewComplaintPage,
})

function SupportNewComplaintPage() {
  return (
    <ContentWrapper>
      <H6>
        Support Ticket
        <br />
        <small className="text-muted">Ask for help with your account</small>
      </H6>

      <ComplaintBanner>
        <H3>Resolving your Complaint</H3>
        <small>
          We'll get back to you within 2 working days and aim to resolve all
          complaints within 10 working days. If we need more time to resolve
          your issue, we'll get in touch with you as soon as possible.
        </small>
      </ComplaintBanner>

      <Card>
        <MakeComplaint />
      </Card>
    </ContentWrapper>
  )
}
